import logo from '@/images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <svg viewBox='0 0 210 66' className='logo logo--wordmark' role='img' aria-label='Charcha'>
    <title>Charcha</title>
    {/* App icon: rounded square with brand purple */}
    <rect x='0' y='3' width='60' height='60' rx='13' fill='#6364FF' />
    {/* च letter in white */}
    <text
      x='30'
      y='47'
      textAnchor='middle'
      fontSize='34'
      fontWeight='bold'
      fill='white'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      च
    </text>
    {/* चर्चा wordmark */}
    <text
      x='74'
      y='49'
      fontSize='40'
      fontWeight='bold'
      fill='currentColor'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      चर्चा
    </text>
  </svg>
);

export const IconLogo: React.FC = () => (
  <svg viewBox='0 0 66 66' className='logo logo--icon' role='img' aria-label='Charcha'>
    <title>Charcha</title>
    <rect x='0' y='0' width='66' height='66' rx='14' fill='#6364FF' />
    <text
      x='33'
      y='48'
      textAnchor='middle'
      fontSize='38'
      fontWeight='bold'
      fill='white'
      fontFamily='system-ui, -apple-system, sans-serif'
    >
      च
    </text>
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt='Charcha' className='logo logo--icon' />
);
